import React, { useRef, useEffect, useCallback, useState } from "react";
import { delay } from "lodash";
import * as S from "./styles";

import slideA1 from "assets/images/section1-slide-A1.jpg";
import slideA2 from "assets/images/section1-slide-A2.jpg";
import slideB1 from "assets/images/section1-slide-B1.jpg";
import slideB2 from "assets/images/section1-slide-B2.jpg";
import slideC1 from "assets/images/section1-slide-C1.jpg";
import slideC2 from "assets/images/section1-slide-C2.jpg";

export const Slide1: React.FC = () => {
  const imageWrapperLeft = useRef<HTMLDivElement>(null);
  const imageWrapperCenter = useRef<HTMLDivElement>(null);
  const imageWrapperRight = useRef<HTMLDivElement>(null);
  const [step, setStep] = useState<number>(1);

  const leftImages = [slideA1, slideA2];
  const centerImages = [slideB1, slideB2];
  const rightImages = [slideC1, slideC2, slideC1];

  const scrollSlide = useCallback(() => {
    if (step === 1) {
      imageWrapperCenter.current?.scrollBy({
        left: 0,
        top: window.innerHeight,
        behavior: "smooth",
      });
      setStep(2);
    }
    if (step === 2) {
      imageWrapperRight.current?.scrollBy({
        left: 0,
        top: window.innerHeight,
        behavior: "smooth",
      });
      setStep(3);
    }
    if (step === 3) {
      imageWrapperLeft.current?.scrollBy({
        left: 0,
        top: window.innerHeight,
        behavior: "smooth",
      });
      imageWrapperRight.current?.scrollBy({
        left: 0,
        top: window.innerHeight,
        behavior: "smooth",
      });
      setStep(4);
    }
    if (step === 4) {
      imageWrapperLeft.current?.scroll({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
      imageWrapperCenter.current?.scroll({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
      imageWrapperRight.current?.scroll({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
      setStep(1);
    }
  }, [step]);

  useEffect(() => {
    delay(scrollSlide, 8000);
  }, [scrollSlide, step]);

  return (
    <S.Container>
      <S.Content className="left">
        <S.ImageWrapper ref={imageWrapperLeft} id="left">
          {leftImages.map((url, index) => (
            <S.Image url={url} key={index} />
          ))}
        </S.ImageWrapper>
      </S.Content>
      <S.Content className="center">
        <S.ImageWrapper ref={imageWrapperCenter} id="center">
          {centerImages.map((url, index) => (
            <S.Image url={url} key={index} />
          ))}
        </S.ImageWrapper>
      </S.Content>
      <S.Content className="right">
        <S.ImageWrapper ref={imageWrapperRight} id="right">
          {rightImages.map((url, index) => (
            <S.Image url={url} key={index} />
          ))}
        </S.ImageWrapper>
      </S.Content>
    </S.Container>
  );
};
